import { IRoleType, IWorkflowData } from '@publishing-engine/domain/models';
import { EditorialRevisionBanner } from './editorial/RevisionBanner';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { EditorialPreProductionBanner } from './editorial/PreProductionBanner';

export interface IBannerProps {
  submissionId: string;
  workflowData: IWorkflowData;
}

type IBanner = (props: IBannerProps) => JSX.Element;

const phaseRoleBanner: Record<string, Record<IRoleType, IBanner | null>> = {
  revision: {
    author: null,
    editorial: EditorialRevisionBanner,
    reviewer: null,
    expert:null
  },
  preProduction: {
    author: null,
    editorial: EditorialPreProductionBanner,
    reviewer: null,
    expert:null
  },
  immediateRevision: {
    author: null,
    editorial: EditorialRevisionBanner,
    reviewer: null,
    expert:null
  },
};

const getBannerForPhase = (phase: string, role: IRoleType) =>
  phaseRoleBanner[phase]?.[role];

export const PhaseBanner = ({ role }: { role: IRoleType }) => {
  const { workflowResponse, submissionId } = useSubmissionData();

  workflowResponse.workflowData;

  const Banner = getBannerForPhase(
    workflowResponse.workflowData.currentState,
    role
  );

  return (
    Banner && (
      <Banner
        submissionId={submissionId}
        workflowData={workflowResponse.workflowData}
      />
    )
  );
};
